export function handleScrollToTop() {
  const elem = document.getElementById("top-anchor");
  elem.scrollIntoView({ behavior: "smooth", block: "end" });
}
